// extracted by mini-css-extract-plugin
module.exports = {"withGrid":"styles__withGrid___14xKO","withoutGrid":"styles__withoutGrid___29VQU"};